(ns hypnos.sleeplab.bar.aside
  "The aside bar."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Bars

(defn primary
  "The primary sidebar."
  []
  (let [panel (rf/subscribe [:sleeplab/active-panel])
        aside (rf/subscribe [:sleeplab/aside])]
    [:aside#aside-main.aside.is-placed-left
     {:class (when (:expanded? @aside) "is-expanded")}
     ;; logo
     [:div.aside-tools
      [:div.aside-tools-label
       (if (:expanded? @aside)
         [:span "Therapist" [:b "Assist"]]
         [:span "T" [:b "A"]])]]
     ;; menu
     [:div.menu-container.jb-has-perfect-scrollbar
      [:div.menu.is-menu-main
       [:p.menu-label "General"]
       [:ul.menu-list
        [:li
         [:a.has-icon.has-submenu-icon.jb-aside-secondary-toggle
          {:class (when (= :dashboard-panel (:name @panel)) "is-active")
           :href  "/dashboard"}
          [:span.icon
           [:i.mdi.mdi-home]]
          [:span.menu-item-label (tr :ui.label/dashboard)]
          [:div.submenu-icon
           [:span.icon [:i.mdi.mdi-chevron-right]]]]]
        [:li
         [:a.has-icon
          {:class (when (contains? #{:patients-panel :patient-panel} (:name @panel)) "is-active")
           :href  "/patients"}
          [:span.icon
           [:i.mdi.mdi-account-multiple]]
          [:span.menu-item-label (tr :ui.label/patients)]]]]]]
     ;; bottom
     [:div.menu.is-menu-bottom
      [:ul.menu-list
       #_[:li
          [:a.is-active.has-icon.is-hoverable
           {:href "#"}
           [:span.icon [:i.mdi.mdi-help-circle-outline]]
           [:span.menu-item-label (tr :ui.label/help)]]]
       [:li
        [:a.is-active.has-icon.is-state-info.is-hoverable
         {:href "#"}
         [:span.icon
          {:on-click (fn [_] (rf/dispatch [:sleeplab/logout]))}
          [:i.mdi.mdi-logout.default]]
         [:span.menu-item-label (tr :ui.label/logout)]]]]]]))

(defn secondary
  "The secondary sidebar"
  []
  [:aside#aside-secondary.aside.is-placed-left.is-secondary.is-hidden
   [:div.aside-tools.has-iconsla
    [:div.aside-tools-label
     [:span "T" [:b "A"]]]]])
